import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ChipList from '@components-clean/core/chip-list';
import { useUnsavedChangesContext } from '@contexts-clean/unsaved-changes-context';
// eslint-disable-next-line max-len
import FunctionalDataReviewsGrid from '@pages-clean/risk-assessment/critical-to-quality-factors/sections/ctq-factors/sections/risks-reviews/functional-data-reviews-grid';
import RisksGrid from '@pages-clean/risk-assessment/critical-to-quality-factors/sections/ctq-factors/sections/risks-reviews/risks-grid';
import { RisksReviewsChipValues } from '@pages-clean/risk-assessment/critical-to-quality-factors/types';
import { CTQFactorsContext } from '@pages-clean/risk-assessment/interfaces/context';

interface RisksReviewsGridsProps {
    selectedRiskId: string | null;
}

const RisksReviewsGrids = ({ selectedRiskId }: RisksReviewsGridsProps) => {
    const { t }: { t: (key: string) => string } = useTranslation('ram', {
        keyPrefix: 'ctqf',
    });
    const { current, setCurrent } = useContext(CTQFactorsContext);
    const { anyComponentHasChanges } = useUnsavedChangesContext();

    return (
        <>
            <ChipList
                // We use a compound key here to prevent a bug with the focus state of the chiplist causing
                // some rerenders to steal focus from input elements
                key={String(anyComponentHasChanges())}
                data-testid="risks-reviews-chip-list"
                data={[
                    {
                        text: t('chips.risks'),
                        value: RisksReviewsChipValues.Risks,
                    },
                    {
                        text: t('chips.functionalDataReviews'),
                        value: RisksReviewsChipValues.FunctionalDataReviews,
                    },
                ]}
                value={current.selectedChildTab}
                onChange={(event) => {
                    const selectedChip = event.value as RisksReviewsChipValues;
                    if (selectedChip) {
                        setCurrent((prevState) => ({
                            ...prevState,
                            selectedChildTab: selectedChip,
                        }));
                    }
                }}
                className="mb-10"
            />
            <div style={{ minHeight: '170px', height: 'calc(100% - 34px - var(--ram-ctqf-detail-height))' }}>
                {current.selectedChildTab === RisksReviewsChipValues.Risks && (
                    <RisksGrid selectedRiskId={selectedRiskId} key={`risks-${selectedRiskId}`} />
                )}
                {current.selectedChildTab === RisksReviewsChipValues.FunctionalDataReviews && (
                    <FunctionalDataReviewsGrid key={`fdrs-${selectedRiskId}`} />
                )}
            </div>
        </>
    );
};

export default RisksReviewsGrids;
